import { SelectMenu } from "./SelectSection"
import useSWR from "swr";

export default function CurrencySelector({setCurrencyAndRate, setSelected, currency}) {
	let {
		data: rates, 
    	error,
    	isValidating
	} = useSWR("https://circlejourney.net/commissions/getcache.php?q=data", fetcher);
    
    if(isValidating) return <div className="currency-selector">Loading currency rates...</div>;
    if(error) rates = { data: {"USD": 1} };

    return (<SelectMenu
        label="Currency"
        attribute="currency"
        className="currency-selector"
        optionList={
            Object.keys(rates.data).map( (val, i) => { return {"index": i,"label": val, "value": val} } )
        }
        value={currency}
        onChange={(attr, newCurrency)=>{
		    setCurrencyAndRate(newCurrency, rates.data[newCurrency]);
        }}
    />)
}

function fetcher (...args) {
	return fetch(...args).then(res => res.json());
}

export function calculatePrice(basePrice, currency, rate) {
    return currency + " " + (Math.round(basePrice*rate * 10)/10).toFixed(2);
}